import { tremorBadgeStyle } from '../styles';

// Pale-tint pill matching the original Tremor <Badge> (see tremorBadgeStyle).
export const GetBadgeForversion = (device) => {
  return <span style={tremorBadgeStyle(device.verColor)}>{'Ver:' + device.verDesc}</span>;
}; //"Ver:" + item.versionNumber,
